import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;
export const FILE_BASE = BASE; // /api/uploads/... is appended via url field already

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("st_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

export const resolveAssetUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${BASE}${path}`;
};
